<div class="fixed z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
  <!-- Background Overlay -->
  <div class="fixed inset-0 bg-[#363738] dark:bg-[#3333331f] bg-opacity-25 transition-opacity backdrop-blur-sm"></div>
  <div class="fixed inset-0 overflow-hidden">
    <div class="absolute inset-0 overflow-hidden">
      <div class="fixed inset-y-0 right-0 flex max-w-full pl-4 sm:pl-8">
        <div class="w-screen max-w-xl px-4 py-4">
          <!-- Modal Content -->
          <div class="flex flex-col px-4 py-4 overflow-y-auto">
            <div class="fixed z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
              <!-- Background Overlay -->
              <div
                class="fixed inset-0 bg-[#D4D7DE] dark:bg-[#3333331f] bg-opacity-25 transition-opacity backdrop-blur-sm">
              </div>
              <div class="fixed inset-0 overflow-hidden">
                <div class="absolute inset-0 overflow-hidden">
                  <div class="fixed inset-y-0 right-0 flex max-w-full pl-4 sm:pl-8">
                    <div class="w-screen max-w-lg px-4 py-4">
                      <!-- Modal Container -->
                      <div
                        class="flex h-full flex-col overflow-y-hidden bg-white dark:bg-zinc-950 shadow-xl rounded-lg">
                        <!-- Header Section -->
                        <div class="flex justify-between items-center py-3 px-4 bg-primary dark:bg-white/5">
                          <div class="flex flex-1 items-center gap-2">
                            <div class="size-12 rounded-full overflow-hidden bg-gray-100">
                              <img src="{{member?.profileImageURL ? member?.profileImageURL : 'assets/images/company-placeholder.png'}}" alt="Profile Image">
                            </div>
                            <div>
                              <div class="text-white font-bold leading-tight">
                                {{(member?.displayName) | titlecase}}
                              </div>
                              <div class="text-white/80 text-sm leading-tight">
                                {{member?.email}}
                              </div>
                            </div>
                          </div>
                          <div class="flex justify-end">
                            <button type="button" (click)="onCloseModal()"
                              class="rounded-lg p-1 text-left text-base/6 font-medium text-white sm:text-sm/5 hover:bg-white/5">
                              <span class="sr-only">Close panel</span>
                              <svg class="size-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                              </svg>
                            </button>
                          </div>
                        </div>
                        <!-- Modal Content -->
                        <div class="flex flex-col px-4 py-2 overflow-y-auto">
                            <dl class="divide-y divide-gray-100 dark:divide-gray-800">
                            
                              <!-- DOB -->
                              <div class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                  DOB</dt>
                                <dd class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                  {{member?.dateOfBirth | dobFormatter:'MM/DD/YYYY'}}</dd>
                              </div>
                              <!-- Gender -->
                              <div class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                  Gender </dt>
                                <dd class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                  {{member?.gender  ? ((member?.gender) | titlecase) : 'N/A'}}</dd>
                              </div>
                              <!-- weight -->
                              <div class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                  Weight (lbs)</dt>
                                <dd class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                  {{member?.weight ? member.weight : 'N/A'}}</dd>
                              </div>
                            
                              <!-- Contact -->
                              <div class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                  Contact Number</dt>
                                <dd class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0" phoneNumberFormat [phoneNumber]="member?.contactNumber">
                                  {{member?.contactNumber}}</dd>
                              </div>
                              <!-- Address -->
                              <div class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                  Address</dt>
                                <dd class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                  {{member?.address?.name ? (member?.address?.name) : 'N/A'}}</dd>
                              </div>
                              <!-- Spoken languages -->
                              <div class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                  Spoken Languages </dt>
                                <dd class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                  <span class="">
                                        {{member?.languageSpoken ? ((member?.languageSpoken)| titlecase) : 'N/A'}}
                                    </span>
                                </dd>
                              </div>
                              <!-- type -->
                              <div class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                  Member Type</dt>
                                <dd class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                <div class="badge-primary"> {{member?.memberType | titlecase}}</div>
                                </dd>
                              </div>

                              <!-- type -->
                              <div class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                  Payment Type</dt>
                                <dd class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                <div class="badge-primary"> {{member?.paymentType | titlecase}}</div>
                                </dd>
                              </div>

                               <!-- Payment Option -->
                              <div *ngIf="member?.paymentType !== 'none'" class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                  Payment Option</dt>
                                <dd class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                <div class="badge-primary"> {{member?.paymentOption | titlecase}}</div>
                                </dd>
                              </div>

                              <!-- Appointment Type -->
                              <div class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                  Appointment Type </dt>
                                <dd class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                  <span *ngIf="member?.appointmentType && preAppointmentTypes?.[member.appointmentType]; else typeNotFound">
                                        {{ preAppointmentTypes[member.appointmentType]?.title | titlecase }}
                                    </span>
                                    <ng-template #typeNotFound>N/A</ng-template>
                                </dd>
                              </div>
                              <!-- Level Of Service -->
                              <div class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                  Level of Service </dt>
                                <dd class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                 <span *ngIf="member?.levelOfService && preLevelOfServiceList?.[member.levelOfService]; else losNotFound">
                                        {{ preLevelOfServiceList[member.levelOfService]?.title | uppercase}}
                                    </span>
                                    <ng-template #losNotFound>N/A</ng-template>
                                </dd>
                              </div>
                              <!--Funding Source-->
                              <div class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                  Funding Source</dt>
                                <dd class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                    <span *ngIf="member?.fundingsource && preFundingSource?.[member.fundingsource]; else typeNotFound">
                                        {{ preFundingSource[member.fundingsource]?.title | titlecase}}
                                    </span>
                                    <ng-template #typeNotFound>N/A</ng-template>
                                </dd>
                            </div>
                              <!-- prefferedTP -->
                              <div class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt class="text-sm font-medium text-gray-900 dark:text-gray-300">
                                  Preferred TP
                                </dt>
                                <dd class="mt-1 text-sm text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                  <ng-container *ngIf="member && member.prefferedTP && member.prefferedTP.length > 0; else noPreferredTP">
                                    <div class="flex flex-wrap gap-2">
                                      <ng-container *ngFor="let companyId of member.prefferedTP">
                                        <span *ngIf="preCompanies?.[companyId]" class="badge badge-success">
                                          {{ (preCompanies[companyId]?.name) | titlecase }}
                                        </span>
                                      </ng-container>
                                    </div>
                                  </ng-container>
                                  <ng-template #noPreferredTP>N/A</ng-template>
                                </dd>
                              </div>
                              <!-- RP Name -->
                              <div class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                  Responsible Party Name </dt>
                                <dd *ngIf="member?.responsibleParty" class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                  {{((member?.responsibleParty?.name) | titlecase) || 'N/A' }}</dd>
                              </div>
                              <!-- Responsible Party PhoneNumber -->
                              <div class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                  Responsible Party PhoneNumber</dt>
                                <dd *ngIf="member?.responsibleParty" class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0" phoneNumberFormat [phoneNumber]="member?.responsibleParty?.phoneNumber">
                                  {{member?.responsibleParty?.phoneNumber || 'N/A' }}</dd>
                              </div>
                              <!-- Status -->
                              <div class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                  Status </dt>
                                <dd class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                  <span [ngClass]="{'badge-success': member?.isActive, 'badge-danger': !member?.isActive}">
                                        {{member?.isActive ? 'Active' : 'Inactive'}}
                                    </span>
                                </dd>
                              </div>
                              <div class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <div class="text-sm font-medium text-gray-900 dark:text-gray-300">
                                  Private Notes
                                </div>
                                <div class="mt-1 text-sm text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                  <p class="text-xs text-gray-800 dark:text-gray-300 whitespace-pre-line">
                                    {{ member?.privateNotes ? member?.privateNotes : 'N/A' }}
                                  </p>
                                </div>
                                </div>

                                <div class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                  <div class="text-sm font-medium text-gray-900 dark:text-gray-300">
                                  General Notes
                                </div>
                                  <div class="mt-1 text-sm text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                    <p class="text-xs text-gray-800 dark:text-gray-300 whitespace-pre-line break-all">
                                      {{ member?.generalNotes ? member?.generalNotes : 'N/A' }}
                                    </p>
                                  </div>
                                </div>

                                <!-- Payment Status -->
                              <div class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                  Payment Status 
                                </dt>
                                <dd class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                  <span [ngClass]="{'badge-success': member?.squareCustomer, 'badge-danger': !member?.squareCustomer}">
                                        {{member?.squareCustomer ? 'Enabled' : 'Disabled'}}
                                  </span>
                                </dd>
                              </div>

                              <!-- Payment Methods -->
                              <div class="px-4 py-2 sm:px-0" *ngIf="paymentMethods?.length">
                                <table class="min-w-full text-left">
                                  <thead>
                                    <tr>
                                      <th class="px-3 py-1 text-sm font-medium text-gray-900 dark:text-gray-300 border-b border-zinc-950/10 dark:border-white/10">Card</th>
                                      <th class="px-3 py-1 text-sm font-medium text-gray-900 dark:text-gray-300 border-b border-zinc-950/10 dark:border-white/10">Card Type</th>
                                      <th class="px-3 py-1 text-sm font-medium text-gray-900 dark:text-gray-300 border-b border-zinc-950/10 dark:border-white/10">Exp Date</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr *ngFor="let card of paymentMethods">
                                      <td class="px-3 py-1 text-xs text-gray-800 dark:text-gray-300 border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{ card.cardBrand | titlecase }} ({{ card.last4 }})</td>
                                      <td class="px-3 py-1 text-xs text-gray-800 dark:text-gray-300 border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{ card.cardType || 'N/A' }}</td>
                                      <td class="px-3 py-1 text-xs text-gray-800 dark:text-gray-300 border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{ card.expMonth }}/{{ card.expYear }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </dl>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>